<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :columns="tableColumns"
      :enableSearch="false"
      :queryParams="queryParams"
      :operationBoxStyle="{padding: '0 0 16px'}"
      :requestPromise="loadDataList"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建
      </a-button>
      <template v-slot:status="{text}">
        {{ text === 1 ? '启用' : '禁用' }}
      </template>
      <template v-slot:action="{ record }">
        <a-space>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onSwitchStatus(record)">{{ record.status == 1 ? '禁用' : '启用' }}</a>
        </a-space>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      ref="formEditor"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="rules"
      :title="selectItem && selectItem.id ? '编辑账号' : '新增账号'"
      @cancel="showDialog = false"
      :width="1200"
      @ok="onEditResultEvent"
    >
      <!-- 对应配置项 slot: custom -->
      <template v-slot:custom="{ form }">
        <div class="price-rule-wrap">
          <div class="header-bar">
            <h2 class="main-title">价格规则</h2>
            <span class="tip-desc">提示：基于石基畅联税后价，计算出相应价格，用于系统展示，订单金额计算</span>
          </div>
          <div class="custom-table">
            <div class="table-row" v-for="row in ruleRows" :key="row.label">
              <div class="table-col left-col">{{ row.label }}</div>
              <div class="table-col right-col">
                <!-- 单行横向容器：禁止换行、垂直居中 -->
                <div class="formula-line">
                  <span class="eq-sign">=</span>
                  <span class="form-text">{{ row.formulaText }}</span>

                  <template v-if="row.configKey">
                    <a-form-model-item
                      :prop="`${row.configKey}.${row.valueKey}`"
                      class="inline-form-item"
                    >
                      <a-input-number
                        v-model="form[row.configKey][row.valueKey]"
                        size="small"
                        class="num-input"
                      />
                    </a-form-model-item>
                    <span v-if="row.suffix" class="percent-text">{{ row.suffix }}</span>
                  </template>
                  <template v-else-if="row.field">
                    <!-- 行内表单项：强制无上下外边距，固定宽度 -->
                    <a-form-model-item
                      :prop="row.field"
                      class="inline-form-item"
                    >
                      <a-input-number
                        v-model="form[row.field]"
                        size="small"
                        class="num-input"
                      />
                    </a-form-model-item>
                    <span v-if="row.suffix" class="percent-text">{{ row.suffix }}</span>
                  </template>

                  <span v-if="row.tip" class="red-tip">{{ row.tip }}</span>
                  <a-radio-group
                    v-if="row.showEnabled"
                    :value="form[row.configKey].enabled"
                    class="enable-radio"
                    @change="(e) => onPriceRuleEnabledChange(form, row.configKey, e)"
                  >
                    <a-radio :value="true">启用</a-radio>
                    <a-radio :value="false">关闭</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </SimpleFormEditorDialog>
  </div>
</template>

<script>
import SearchMixins from '../../mixins/SearchMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import {
  editConfigList,
  ruleRows,
  tableColumns
} from '../config/associatedAccount.config.js'
import {
  applyPriceRuleEnabledChange,
  createPriceConfigValidator,
  normalizeAccountItem,
  parseRadioEnabledValue
} from '../utils/priceRule.js'

export default {
  name: 'AssociatedAccountComponent',
  mixins: [SearchMixins],
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      showDialog: false,
      selectItem: undefined,
      queryParams: {},
      searchOptions: [],
      editConfigList,
      ruleRows,
      tableColumns,
      rules: {
        channelUserName: [{ required: true, message: '请输入渠道用户名' }],
        channelCode: [{ required: true, message: '请输入渠道代码' }],
        chainCode: [{ required: true, message: '请输入集团代码' }],
        key: [{ required: true, message: '请输入密钥' }],
        'salePriceRate.salePriceRate': [
          {
            validator: createPriceConfigValidator('salePriceRate')
          }
        ],
        'salePriceSum.salePriceSum': [
          {
            validator: createPriceConfigValidator('salePriceSum')
          }
        ],
        peerPriceRate: [
          { required: true, message: '请填写同行价比例' },
          { type: 'number', min: 0, message: '数值不能小于0' }
        ],
        commissionRate: [
          { required: true, message: '请填写佣金比例' },
          { type: 'number', min: 0, message: '数值不能小于0' }
        ]
      }
    }
  },
  mounted() {

  },
  activated() {
  },
  methods: {
    onPriceRuleEnabledChange(form, configKey, e) {
      applyPriceRuleEnabledChange(form, configKey, parseRadioEnabledValue(e), this.$set)
    },
    loadDataList(params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto: undefined,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      return this.getHttpServices().getSourceService().post('shiji/platform/account_list', requestParams)
    },
    onSwitchStatus(item) {
      const url = 'shiji/platform/account_status_update'
      const params = {
        id: item.id,
        status: String(item.status) === '1' ? 0 : 1
      }
      this.getHttpServices().getSourceService().post(url, params)
        .then(res => {
          this.$message.success('操作成功！')
          this.refreshData(false)
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    },
    onEditEvent(item) {
      this.selectItem = normalizeAccountItem(item)
      this.showDialog = true
    },
    onAddEvent() {
      this.selectItem = normalizeAccountItem()
      this.showDialog = true
    },
    refreshData() {
      this.$refs.table.refresh()
    },
    onEditResultEvent(params) {
      const url = params.id ? 'shiji/platform/account_edit' : 'shiji/platform/account_create'
      const requestParams = {
        ...params,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getSourceService().post(url, requestParams)
        .then(res => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          const isEdit = !!params.id
          this.refreshData(!isEdit)
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-tabs-bar {
  margin-top: 0 !important;
}

.price-rule-wrap {
  margin-top: 10px;

  .header-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .main-title {
      font-size: 22px;
      font-weight: 600;
      margin: 0;
    }

    .tip-desc {
      color: #666;
      font-size: 14px;
    }
  }

  .custom-table {
    width: 100%;
    border: 1px solid #e8e8e8;

    .table-row {
      display: flex;
      border-bottom: 1px solid #e8e8e8;
      align-items: center; /* 整行垂直居中，不会被报错文字撑高 */
      min-height: 64px; /* 固定行高基准 */

      &:last-child {
        border-bottom: none;
      }

      .table-col {
        padding: 8px 10px;
        font-size: 16px;
      }

      .left-col {
        width: 140px; /* 缩小左侧宽度，腾出右侧空间 */
        flex-shrink: 0;
        background: #f7f7f7;
        text-align: right;
      }

      .right-col {
        flex: 1;
      }
    }
  }

  .formula-line {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap; /* 禁止整行自动换行，解决排版撕裂 */

    .eq-sign {
      flex-shrink: 0;
    }

    .form-text {
      flex-shrink: 0;
    }

    .percent-text {
      flex-shrink: 0;
    }

    .red-tip {
      color: #333;
      font-weight: bold;
      flex-shrink: 0;
    }

    .enable-radio {
      margin-left: auto;
      flex-shrink: 0;
    }
  }

  // 穿透覆盖antd默认样式，解决变形核心
  /deep/ .inline-form-item {
    margin-bottom: 0 !important;
    margin-left: 8px;
    margin-right: 8px;
    width: 160px; /* 固定表单项整体宽度 */
    flex-shrink: 0; // 输入框区域不压缩
  }

  /deep/ .num-input {
    width: 100%;
  }

  // 校验提示文字：单行、缩小、不撑开行高
  /deep/ .ant-form-item-explain {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute; // 脱离文档流，不会撑高表格行
    margin-top: 2px;
  }
}
</style>
